<template>
  <div class="p-postEditor__itemWrapper">
    <div v-if="editingItemIndex != index" @click="editItem">
      <item-preview :item="item" />
    </div>
    <item-form v-if="editingItemIndex == index" :item="item">
      <div class="px-5">
        <v-text-field
          v-model="url"
          :rules="[presenceValidation, urlValidation]"
          label="URL"
          autofocus
          required
          persistent-hint
          hint="※埋め込みたいurlを入力してください。"
        />
        <v-btn class="mt-3 mb-4" tile small @click="fetchOembed">
          <v-icon class="mr-2" small> mdi-reload </v-icon>
          urlを埋込みに変換する
        </v-btn>
        <v-card outlined>
          <v-chip small depressed label class="ma-1"> プレビュー </v-chip>
          <v-card-text>
            <div
              v-if="editingItemable.data"
              v-html="editingItemable.data.html"
            />
            <div v-else-if="editingItemable.variety == 'error'">
              エラーが発生しました。<br />
              時間をおいて再度お試しいただくか、urlが正しいかご確認ください。
            </div>
            <div v-else>
              <strong
                >保存する前に必ず、「urlを埋込みに変換する」を押してください。</strong
              >
            </div>
          </v-card-text>
        </v-card>
        <v-textarea
          :value="editingItemable.content"
          class="body-2"
          label="説明文"
          rows="1"
          @input="(value) => updateEditingItemable(value, 'content')"
        />
      </div>
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import axios from 'axios'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'EmbeddingItem',
  mixins: [itemUtilsMixin, formValidationUtils],
  computed: {
    url: {
      get () {
        if (this.item.itemableAttributes.url) {
          return this.item.itemableAttributes.url
        } else {
          return this.$store.state.editingItemable
        }
      },
      set (value) {
        this.updateEditingItemable(value, 'url')
      }
    }
  },
  updated () {
    this.runScript()
  },
  methods: {
    fetchOembed () {
      axios.get(`/api/oembed?url=${this.editingItemable.url}`).then(
        ({ data }) => {
          const attributes = data.data.attributes
          this.updateEditingItemable(attributes.data, 'data')
          this.updateEditingItemable(attributes.variety, 'variety')
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    runScript () {
      const scripts = this.$el.querySelectorAll('script')
      scripts.forEach((script) => {
        const parentNode = script.parentNode
        let alternativeNode
        // todo: ホワイトリスト方式にする
        if (script.src.indexOf('https://gist.github.com/') !== -1) {
          alternativeNode = document.createElement('iframe')
          alternativeNode.src = URL.createObjectURL(
            new Blob(['<!DOCTYPE html><title></title>' + script.outerHTML], {
              type: 'text/html'
            })
          )
          alternativeNode.onload = () => {
            alternativeNode.height =
              alternativeNode.contentDocument.body.scrollHeight + 50
          }
        } else {
          alternativeNode = document.createElement('script')
          alternativeNode.src = script.src
        }
        parentNode.replaceChild(alternativeNode, script)
      })
    }
  }
}
</script>

<style scoped></style>
